import React from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './CompareScansTable.module.scss';
import { ScanBodyMetrics } from '../../../../../../interfaces/keyBodyMetricsInfo';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../../../../shared/components/table-components';
import { getFormattedDate } from '../../../../../../../shared/utils/dateUtils';
import {
  dateTimeFormat,
  localDataFormat,
} from '../../../../../../../shared/constants/apiDateFormat';
import { CompareValueCell } from './CompareValueCell/CompareValueCell';
import { roundFields } from '../../../../../../../shared/utils/objUtils';

type CompareScansTableProps = {
  compareTitle: string;
  compareMetrics: ScanBodyMetrics;
  currentMetrics: ScanBodyMetrics;
};

const CompareScansTable = ({
  compareTitle,
  compareMetrics,
  currentMetrics,
}: CompareScansTableProps) => {
  const ignoreFields: (keyof ScanBodyMetrics)[] = ['scanDateTime', 'scanId'];

  const roundedCompareMetrics = roundFields(compareMetrics, {
    ignoreFields,
  });

  const roundedCurrentMetrics = roundFields(currentMetrics, {
    ignoreFields,
  });

  return (
    <div className={classes.keyBodyMetricsTable}>
      <GridTableRow variant="unstyled" className={classes.headerRow}>
        <GridTableCell>
          {compareTitle} InBody Scan <br />
          Comparison
        </GridTableCell>
        <GridTableCell>
          <TitleWithDescription title="Weight" description="lbs" titleFont="inherit" />
        </GridTableCell>
        <GridTableCell>
          <TitleWithDescription title="Body Fat" description="lbs" titleFont="inherit" />
        </GridTableCell>
        <GridTableCell>
          <TitleWithDescription title="Body Fat" description="%" titleFont="inherit" />
        </GridTableCell>
        <GridTableCell>
          <TitleWithDescription title="LBM" description="lbs" titleFont="inherit" />
        </GridTableCell>
      </GridTableRow>
      <GridTableRow variant="unstyled" className={classes.row}>
        <GridTableCell variant="title" className={classes.titleCell}>
          <span>{compareTitle} InBody Scan</span>
          <span className={classes.description}>
            {getFormattedDate(
              compareMetrics.scanDateTime,
              localDataFormat,
              dateTimeFormat,
            )}
          </span>
        </GridTableCell>
        <GridTableCell>{roundedCompareMetrics.weight}</GridTableCell>
        <GridTableCell>{roundedCompareMetrics.bodyFat}</GridTableCell>
        <GridTableCell>{roundedCompareMetrics.percentBodyFat}%</GridTableCell>
        <GridTableCell>{roundedCompareMetrics.leanBodyMass}</GridTableCell>
      </GridTableRow>
      <GridTableRow variant="unstyled" className={classes.row}>
        <GridTableCell variant="title" className={classes.titleCell}>
          <span>Current InBody Scan</span>
          <span className={classes.description}>
            {getFormattedDate(
              currentMetrics.scanDateTime,
              localDataFormat,
              dateTimeFormat,
            )}
          </span>
        </GridTableCell>
        <GridTableCell>
          <CompareValueCell
            currentValue={roundedCurrentMetrics.weight}
            previousValue={roundedCompareMetrics.weight}
            unit="lbs"
            showColorIndicator={false}
          />
        </GridTableCell>

        <GridTableCell>
          <CompareValueCell
            currentValue={roundedCurrentMetrics.bodyFat}
            previousValue={roundedCompareMetrics.bodyFat}
            unit="lbs"
          />
        </GridTableCell>
        <GridTableCell>
          <CompareValueCell
            currentValue={roundedCurrentMetrics.percentBodyFat}
            previousValue={roundedCompareMetrics.percentBodyFat}
            unit="%"
            showUnitNearValue
          />
        </GridTableCell>
        <GridTableCell>
          <CompareValueCell
            currentValue={roundedCurrentMetrics.leanBodyMass}
            previousValue={roundedCompareMetrics.leanBodyMass}
            unit="lbs"
            gainIsGood
          />
        </GridTableCell>
      </GridTableRow>
    </div>
  );
};

export { CompareScansTable };
